(function() {
    'use strict';

    angular.module('app').directive('validationStyles', validationStyles);

    function validationStyles() {
        return {restrict: 'A', link: link};

        function link(scope, element, attrs) {
            element.ready(apply);

            function apply() {
  
                // $(scope).$watch('', function(){

                // });
            }
        }
    }

})();
